import { render, staticRenderFns } from "./MarkdownRenderer.vue?vue&type=template&id=56fa2639&"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=ts&"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownRenderer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports